import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-1998')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('drawing') || media.includes('painting') || media.includes('installation') || media.includes('sculpture');
  })
  .slice(0, 4);

export default function DoHoSuh() {
  const slides = [
    { src: '/uploads/doho1.jpg', alt: 'Do-Ho Suh work 1' },
    { src: '/uploads/doho1-1.jpg', alt: 'Do-Ho Suh work 2' },
    { src: '/uploads/doho2.jpg', alt: 'Do-Ho Suh work 3' },
    { src: '/uploads/doho3.jpg', alt: 'Do-Ho Suh work 4' },
    { src: '/uploads/doho15.jpg', alt: 'Do-Ho Suh work 5' },
    { src: '/uploads/Do-ho-suh_1280x847.jpg', alt: 'Do-Ho Suh work 6' },
    { src: '/uploads/doho6.jpg', alt: 'Do-Ho Suh work 7' },
    { src: '/uploads/doho7.jpg', alt: 'Do-Ho Suh work 8' },
    { src: '/uploads/doho8.jpg', alt: 'Do-Ho Suh work 9' },
    { src: '/uploads/doho9.jpg', alt: 'Do-Ho Suh work 10' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Do-Ho Suh</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Do-Ho Suh slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>1998</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>The three artists recognized by this year’s KAFA jury display very different sensibilities, but they share one very important characteristic (besides their Korean heritage and American milieu): all three are committed to, and unusually skilled at creating, a powerful, almost magical sense of transformation. In equally surprising and beautiful ways, Do-Ho Suh, Byoung Li and Young Kim challenge our perceptions of reality by altering the space we traverse. San Francisco’s Young Kim does this with an inward-turning restraint, documenting herself with a formidable single-mindedness, one photo at a time, over a several-year period – and, then, turning a similarly multi-part tableful of water-bearing bowls into so many miniature oceans. Byoung Li of Los Angeles turns the sterile rooms of a public gallery into a garden of vivid, almost hallucinatory color and rhythmic, playful, even unpredictable geometric shapes – all created as much with light projection as with sculptural manipulation. The jurors awarded New York-based Do-Ho Suh the grand prize because his work evinces the stylistic breadth seen in Young Kim’s art with the sensitivity to material and to abstract, optical effect in Byoung Li’s. Suh’s extra-sculptural inventions, whether fabric, rubber, wood, paper, clothing or photography, speak to our nature both as sentient beings and as sensate beings. They appeal alternately to our touch and our sight, our physical experience, and our cultural memory, our passage through architectural space and the limitations of our minds and bodies.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Peter Frank, Art Critic, L.A. Weekly, ArtNews</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Henry Hopkins, Former Chairman, Art Dept. University of California, Los Angeles</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Julie Lazar, Director of Experimental Program, Museum of Contemporary Art, Los Angeles</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Do Ho Suh (b.1962, Seoul, Korea) received a BFA in painting from the Rhode Island School of Design and a MFA in sculpture from Yale University. Interested in the malleability of space in both its physical and metaphorical manifestations, Do Ho Suh constructs site-specific installations that question the boundaries of identity. His work explores the relation between individuality, collectivity, and anonymity.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Do Ho Suh was named WSJ. Magazine’s 2013 Innovator of the Year in Art. His recent solo exhibitions and projects include Home within Home within Home within Home within Home, National Museum of Modern and Contemporary Art, Seoul, Korea (2013); Do Ho Suh: Perfect Home, 21st Century Museum of Contemporary Art, Kanazawa, Japan (2012-2013); In Between, Hiroshima City Museum of Contemporary Art, Hiroshima, Japan (2012); Fallen Star, Stuart Collection, University of San Diego, California (2012); Home within Home, Leeum, Samsung Museum of Art, Seoul, Korea (2012); and Wielandstr.18, 12159, DAAD Galerie, Germany (2011). In 2001, Suh represented Korea at the Venice Biennale and subsequently participated in the 2010 Venice Architecture Biennale, the 2010 Liverpool Biennial, and the 2012 Gwangju Biennial.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>The artist’s work is included in numerous museum collections worldwide including the Museum of Modern Art, New York; Whitney Museum of American Art, New York; The Solomon R. Guggenheim Museum, New York; Los Angeles County Museum of Art, Los Angeles; Walker Art Center, Minneapolis; Tate, London; Leeum, Seoul; Artsonje Center, Seoul; Museum of Contemporary Art, Tokyo; Mori Art Museum, Tokyo; and 21st Century Museum of Contemporary Art, Kanazawa, among many others. The artist lives and works in New York, London, and Seoul.</p>

            {/* <a href='placeholder' className='nav-link'>Artist's Website</a> */}
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
